// extracted by mini-css-extract-plugin
module.exports = {"container":"DataCollectionTable_container_3ZJ5D","table":"DataCollectionTable_table_3WFDf","spinAround":"DataCollectionTable_spinAround_2TAE_"};